import { render } from "preact"
import { ErrorBoundary, LocationProvider, Route, Router } from "preact-iso"
import type { Brand } from "@/modules/layout/main"

export function LetsGo(brand: Brand) {
	function App() {
		return (
			<LocationProvider>
				<ErrorBoundary>
					<Router>
						{brand.Routes.map((menuItem) => {
							return (
								<Route component={menuItem.Component} path={menuItem.Href} />
							)
						})}
						<Route component={brand.Page404} path="*" />
					</Router>
				</ErrorBoundary>
			</LocationProvider>
		)
	}

	render(<App />, document.getElementById("app") as HTMLDivElement)
}
